module.exports = __webpack_public_path__ + "img/inspeccion1.fa67b337.jpg";